import { Component } from '@angular/core';

// todo implement proper routing
@Component({
    selector: 'cfn-login',
    template: `
      <div id="viewDiv" class="full-height-minus-footer ng-view"></div>
    `
})
export class LoginComponent {
}